import { ApolloError } from "@apollo/client";
import { Box, Grid } from "@mui/material";
// import { ActivityLibrary } from "pages/ActivityLibrary";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { DefaultAppPage } from "../../layouts";
import { Title } from "../../layouts/AppPage/styles";
import { ActivityDetailForm } from "./components/ActivityDetailForm";
import { EditViewToggle } from "./components/EditViewToggle";

import { useQuery } from "@apollo/client";
import { CognitiveDomain, StatusView, VoiceMessage } from "../../types/api";

import { getEnumName } from "types/utils";
import { GET_ALL_ACTIVITIES } from "pages/ActivityLibrary/queries";

export const ActivityDetails = () => {
  const [editView, setEditView] = useState<boolean>(false);
  const [singleActivityError, setSingleActivityError] = useState<ApolloError>();
  const [filterCogDomain, setfilterCogDomain] = useState<
    CognitiveDomain | undefined
  >(undefined);
  const [activityFilterStatus, setActivityFilterStatus] =
    useState<string>("Active");
  const { id } = useParams();
  const activityId: number = parseInt(id ?? "") || 0;

  type AllActivitiesResponse = {
    voiceMessages: { count: number; data: VoiceMessage[] };
  };

  const { data } = useQuery<AllActivitiesResponse>(GET_ALL_ACTIVITIES, {
    fetchPolicy: "network-only",
    variables: {
      inLibrary: true,
      statusView: getEnumName(StatusView, activityFilterStatus),
      cognitiveDomain: getEnumName(CognitiveDomain, filterCogDomain),
    },
  });
  const activityLibrary = data?.voiceMessages?.data ?? [];

  return (
    <DefaultAppPage>
      <Box sx={{ width: "100%" }}>
        <Grid
          container
          justifyContent="space-between"
          sx={{ paddingBottom: "0.5rem" }}
        >
          <Grid item xs={6} justifyContent="space-between">
            <Title>Activity Detail</Title>
          </Grid>
          <Grid item>
            <EditViewToggle editView={editView} setEditView={setEditView} />
          </Grid>
        </Grid>
        {singleActivityError && "Error loading data"}
        <ActivityDetailForm
          setActivityFilterStatus={setActivityFilterStatus}
          allData={activityLibrary}
          activityId={activityId}
          isOpen={true}
          editView={editView}
          setEditView={setEditView}
          setSingleActivityError={setSingleActivityError}
        />
      </Box>
    </DefaultAppPage>
  );
};
